import { QueryFilterOption } from '../models/query-option.model';

export const QUERY_FILTER_OPTIONS = {
  any: new QueryFilterOption('Is Any Of', 'any'),
  not_any: new QueryFilterOption('Is Not Any Of', 'not_any'),
  cts: new QueryFilterOption('Contains', 'cts'),
  not_cts: new QueryFilterOption('Does Not Contain', 'not_cts'),
  eq: new QueryFilterOption('Is Equal To', 'eq'),
  not_eq: new QueryFilterOption('Is Not Equal To', 'not_eq'),
  begins_with: new QueryFilterOption('Begins With', 'begins_with'),
  ends_with: new QueryFilterOption('Ends With', 'ends_with'),
  na: new QueryFilterOption('Is N/A or Empty', 'na'),
  not_na: new QueryFilterOption('Is Not N/A or Empty', 'not_na'),
  metric_na: new QueryFilterOption('Is N/A', 'na'),
  metric_not_na: new QueryFilterOption('Is Not N/A', 'not_na'),
  gt: new QueryFilterOption('Is Greater Than', 'gt'),
  gte: new QueryFilterOption('Is Greater Than or Equal To', 'gte'),
  lt: new QueryFilterOption('Is Less Than', 'lt'),
  lte: new QueryFilterOption('Is Less Than or Equal To', 'lte'),
  is_in: new QueryFilterOption('Is In', 'is_in'),
  not_is_in: new QueryFilterOption('Is Not In', 'not_is_in'),
};

export const METRIC_FILTER_OPTIONS = [
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.metric_na,
  QUERY_FILTER_OPTIONS.metric_not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
];

export const QUERY_GLOBAL_OPTION_FILTERS = [
  QUERY_FILTER_OPTIONS.any,
  QUERY_FILTER_OPTIONS.not_any,
  QUERY_FILTER_OPTIONS.cts,
  QUERY_FILTER_OPTIONS.not_cts,
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.begins_with,
  QUERY_FILTER_OPTIONS.ends_with,
  QUERY_FILTER_OPTIONS.na,
  QUERY_FILTER_OPTIONS.not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
  QUERY_FILTER_OPTIONS.is_in,
  QUERY_FILTER_OPTIONS.not_is_in,
];

export const QUERY_WIDGET_OPTION_FILTERS = [
  QUERY_FILTER_OPTIONS.any,
  QUERY_FILTER_OPTIONS.not_any,
  QUERY_FILTER_OPTIONS.cts,
  QUERY_FILTER_OPTIONS.not_cts,
  QUERY_FILTER_OPTIONS.eq,
  QUERY_FILTER_OPTIONS.not_eq,
  QUERY_FILTER_OPTIONS.begins_with,
  QUERY_FILTER_OPTIONS.ends_with,
  QUERY_FILTER_OPTIONS.na,
  QUERY_FILTER_OPTIONS.not_na,
  QUERY_FILTER_OPTIONS.gt,
  QUERY_FILTER_OPTIONS.gte,
  QUERY_FILTER_OPTIONS.lt,
  QUERY_FILTER_OPTIONS.lte,
  QUERY_FILTER_OPTIONS.is_in,
  QUERY_FILTER_OPTIONS.not_is_in,
];

export const CHIP_FILTER_OPERATORS = ['cts', 'begins_with', 'ends_with', 'eq'];
export const MAX_FILTER_VALUES = 30;

export const EMPTY_VALUES_WARNING = 'emptyValuesWarning';

export const DEFAULT_QUERY_INTERVAL = '19700101-20700101';
